import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const offices = [
  { label: 'Dakar Office',    flag: '🇸🇳', number: '221777278596' },
  { label: 'Abidjan Office',  flag: '🇨🇮', number: '2250719887362' },
  { label: 'Conakry Office',  flag: '🇬🇳', number: '224669059915' },
  { label: 'Jaipur Office',   flag: '🇮🇳', number: '919587532127' }
];

const quickMessages = [
  "Hi! I'd like to know more about flight booking offers.",
  "Hi! I need help with visa assistance.",
  "Hi! Can you share holiday package options?",
  "Hi! I have a general travel question."
];

export default function WhatsAppButton() {
  const { t } = useTranslation();
  const [open, setOpen]             = useState(false);
  const [selectedOffice, setSelectedOffice] = useState(null);

  function handleOfficeSelect(office) {
    setSelectedOffice(office);
  }

  function handleBack() {
    setSelectedOffice(null);
  }

  function handleClose() {
    setOpen(false);
    setSelectedOffice(null);
  }

  return (
    <div className="whatsapp-float" style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 100 }}>

      {/* Popup panel */}
      {open && (
        <div className="card" style={{
          marginBottom: 12, width: 280,
          boxShadow: '0 8px 32px rgba(17,45,78,0.18)',
          borderRadius: 16, overflow: 'hidden'
        }}>
          {/* Header */}
          <div style={{
            background: '#25D366', padding: '14px 16px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.96 7.96 0 01-4.065-1.115l-.291-.173-3.017.897.897-3.017-.173-.291A7.96 7.96 0 014 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8z"/>
              </svg>
              <div>
                <p style={{ margin: 0, color: '#fff', fontWeight: 700, fontSize: '0.9rem', lineHeight: 1 }}>
                  {selectedOffice ? selectedOffice.label : 'Chat with us'}
                </p>
                <p style={{ margin: '2px 0 0', color: 'rgba(255,255,255,0.8)', fontSize: '0.72rem' }}>
                  {selectedOffice ? 'Select a message' : 'Choose an office'}
                </p>
              </div>
            </div>
            <button
              onClick={handleClose}
              style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.8)', cursor: 'pointer', fontSize: '1.1rem', padding: 4, lineHeight: 1 }}
            >
              ✕
            </button>
          </div>

          {/* STEP 1 — Choose office */}
          {!selectedOffice && (
            <div style={{ padding: '8px 0' }}>
              <p style={{ margin: 0, padding: '8px 16px 4px', fontSize: '0.72rem', fontWeight: 700, opacity: 0.45, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                Select office
              </p>
              {offices.map(function(office) {
                return (
                  <button
                    key={office.number}
                    onClick={function() { handleOfficeSelect(office); }}
                    style={{
                      width: '100%', display: 'flex', alignItems: 'center',
                      gap: 12, padding: '11px 16px',
                      background: 'none', border: 'none', cursor: 'pointer',
                      textAlign: 'left', transition: 'background 0.15s',
                      fontFamily: 'var(--font-body)'
                    }}
                    onMouseEnter={function(e) { e.currentTarget.style.background = 'var(--bj-cream-soft)'; }}
                    onMouseLeave={function(e) { e.currentTarget.style.background = 'none'; }}
                  >
                    <span style={{
                      width: 36, height: 36, borderRadius: 8,
                      background: 'var(--bj-cream-soft)',
                      display: 'flex', alignItems: 'center',
                      justifyContent: 'center', fontSize: '1.3rem', flexShrink: 0
                    }}>
                      {office.flag}
                    </span>
                    <div>
                      <p style={{ margin: 0, fontWeight: 600, fontSize: '0.88rem', color: 'var(--bj-espresso)' }}>
                        {office.label}
                      </p>
                      <p style={{ margin: 0, fontSize: '0.75rem', opacity: 0.5 }}>
                        +{office.number}
                      </p>
                    </div>
                    <span style={{ marginLeft: 'auto', opacity: 0.3, fontSize: '0.9rem' }}>›</span>
                  </button>
                );
              })}
            </div>
          )}

          {/* STEP 2 — Choose message */}
          {selectedOffice && (
            <div style={{ padding: '8px 0' }}>
              {/* Back button */}
              <button
                onClick={handleBack}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '8px 16px', background: 'none', border: 'none',
                  cursor: 'pointer', fontFamily: 'var(--font-body)',
                  fontSize: '0.8rem', fontWeight: 600,
                  color: 'var(--bj-clay)', width: '100%', textAlign: 'left'
                }}
              >
                ← Back to offices
              </button>

              <div style={{ height: 1, background: 'var(--bj-sand)', margin: '4px 0' }} />

              <p style={{ margin: 0, padding: '8px 16px 4px', fontSize: '0.72rem', fontWeight: 700, opacity: 0.45, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                Quick message
              </p>

              {quickMessages.map(function(msg) {
                return (
                  <a
                    key={msg}
                    href={'https://wa.me/' + selectedOffice.number + '?text=' + encodeURIComponent(msg)}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: 'flex', alignItems: 'flex-start', gap: 10,
                      padding: '10px 16px',
                      textDecoration: 'none',
                      transition: 'background 0.15s'
                    }}
                    onMouseEnter={function(e) { e.currentTarget.style.background = '#f0fdf4'; }}
                    onMouseLeave={function(e) { e.currentTarget.style.background = 'none'; }}
                  >
                    <span style={{
                      width: 22, height: 22, borderRadius: '50%',
                      background: '#25D36618', border: '1px solid #25D36630',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0, marginTop: 1
                    }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="#25D366">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                        <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.96 7.96 0 01-4.065-1.115l-.291-.173-3.017.897.897-3.017-.173-.291A7.96 7.96 0 014 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8z"/>
                      </svg>
                    </span>
                    <p style={{ margin: 0, fontSize: '0.84rem', color: 'var(--bj-espresso)', lineHeight: 1.5, opacity: 0.82 }}>
                      {msg}
                    </p>
                  </a>
                );
              })}

              {/* Custom message */}
              <div style={{ padding: '8px 16px 4px' }}>
                <a
                  href={'https://wa.me/' + selectedOffice.number}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    gap: 8, padding: '10px',
                    background: '#25D366', borderRadius: 8,
                    color: '#fff', fontWeight: 700, fontSize: '0.85rem',
                    textDecoration: 'none', transition: 'opacity 0.2s'
                  }}
                  onMouseEnter={function(e) { e.currentTarget.style.opacity = '0.85'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.opacity = '1'; }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.96 7.96 0 01-4.065-1.115l-.291-.173-3.017.897.897-3.017-.173-.291A7.96 7.96 0 014 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8z"/>
                  </svg>
                  Open WhatsApp Chat
                </a>
              </div>
            </div>
          )}
        </div>
      )}

      {/* FAB button */}
      <button
        onClick={function() { setOpen(!open); if (open) setSelectedOffice(null); }}
        aria-label="Open WhatsApp chat"
        style={{
          width: 56, height: 56, borderRadius: '50%',
          background: '#25D366', border: 'none',
          cursor: 'pointer', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 4px 16px rgba(37,211,102,0.5)',
          transition: 'transform 0.2s, box-shadow 0.2s'
        }}
        onMouseEnter={function(e) { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(37,211,102,0.6)'; }}
        onMouseLeave={function(e) { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(37,211,102,0.5)'; }}
      >
        {open ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
            <line x1="18" y1="6" x2="6" y2="18" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
            <line x1="6" y1="6" x2="18" y2="18" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        ) : (
          <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.96 7.96 0 01-4.065-1.115l-.291-.173-3.017.897.897-3.017-.173-.291A7.96 7.96 0 014 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8z"/>
          </svg>
        )}
      </button>
    </div>
  );
}